module.exports = "build/assets/monk.530c042a.png";